var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan",class:{dark:_vm.dark}},[_c('h3',[_vm._v("Advertising card")]),_vm._l((_vm.items),function(i){return _c('div',{key:i,staticClass:"work"},[_c('img',{attrs:{"src":'./img/' + i.src}}),_c('p',[_vm._v(_vm._s(i.txt))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }